import furnitureTariff from './furniture-tariff'
import car from './car'
import employee from './employee'
import item from './item'
import trafficPlan from './traffic-plan'
import addon from './addon'

export default {
  name: 'FinancialFurnitureTariff',
  path: 'furniture',
  meta: {
    label: 'furniture',
    auth: 'furniture'
  },
  component: {
    name: 'Furniture',
    render(c) {
      return c('router-view')
    }
  },
  children: [furnitureTariff, car, employee, item, trafficPlan, addon]
}
